
<div *ngIf="stop" class="stop" #stopElement>
    <div class="ibox float-e-margins">
        <div class="ibox-title border-primary no-padding">
            <div [title]="stop.location.name" class="stop-location">
                <ng-container *ngIf="stop.type === 'Pick'">
                    <span class="chep-icon-pick-up stop-location-type"></span>
                    <span class="stop-location-name"
                          [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.collect-from', params: { location: stop.location.name }}]"></span>
                </ng-container>
                <ng-container *ngIf="stop.type === 'Drop'">
                    <span class="chep-icon-drop-off stop-location-type"></span>
                    <span class="stop-location-name"
                          [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.deliver-to', params: { location: stop.location.name }}]"></span>
                </ng-container>

                <div class="stop-location-chep">
                    <img *ngIf="stop.location.type === 'CHEP'" class="chep-logo" src="/assets/chep_logo_white.svg" alt="CHEP"/>
                </div>
            </div>
        </div>

        <div class="ibox-content">
            <div class="stop-dates">
                <div class="stop-date">
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.planned-arrival'}]"></span>
                    <span>{{ (stop.plannedArrival | fullDate) || '-' }}</span>
                </div>
                <div class="stop-date" [ngClass]="{ 'done': !!stop.eta, 'planned': !stop.eta }">
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.eta'}]"></span>
                    <span>{{ (stop.eta | fullDate) || '-' }}</span>
                    <i class="fa fa-check-circle stop-done-icon" *ngIf="!!stop.eta"></i>
                </div>
                <div class="stop-date" [ngClass]="{ 'done': !!stop.actualArrival, 'planned': !stop.actualArrival }">
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.actual-arrival'}]"></span>
                    <span>{{ (stop.actualArrival | fullDate) || '-' }}</span>
                    <i class="fa fa-check-circle stop-done-icon" *ngIf="!!stop.actualArrival"></i>
                </div>
                <div class="stop-date" [ngClass]="{ 'done': !!stop.actualDeparture, 'planned': !stop.actualDeparture }">
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.actual-departure'}]"></span>
                    <span>{{ (stop.actualDeparture | fullDate) || '-' }}</span>
                    <i class="fa fa-check-circle stop-done-icon" *ngIf="!!stop.actualDeparture"></i>
                </div>
            </div>

            <a (click)="stop.expandMap()">
                <ng-container *ngIf="!stop.mapExpanded">
                    <i class="fa fa-eye"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.show-map'}]"></span>
                </ng-container>
                <ng-container *ngIf="stop.mapExpanded">
                    <i class="fa fa-eye-slash"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.hide-map'}]"></span>
                </ng-container>
            </a>

            <div class="stop-location-map" *ngIf="stop.mapExpanded">
                <agm-map [latitude]='stop.location.latitude' [(zoom)]="zoom" [longitude]='stop.location.longitude' [disableDefaultUI]="true">
                    <agm-zoom-control></agm-zoom-control>
                    <agm-marker [latitude]='stop.location.latitude' [longitude]='stop.location.longitude'></agm-marker>
                </agm-map>
            </div>

            <div class="stop-location-address">
                <div>{{ stop.location.address.address1 + (stop.location.address.address2 ? ', ' + stop.location.address.address2 : '') + (stop.location.address.address3 ? ', ' + stop.location.address.address3 : '') }}</div>
                <div>
                    {{ stop.location.address.zip + ' ' + stop.location.address.city }},
                    {{ stop.location.address.state ? stop.location.address.state + ', ' : ''}} {{stop.location.address.country }}</div>
            </div>

            <div class="ibox float-e-margins stop-shipment" *ngFor="let shipment of stop.shipments">
                <div class="ibox-title collapsible border-primary" [class.collapsed]="!shipment.expanded"
                     (click)="expandShipment(shipment)">
                    <h2>
                        <span [popover]="salesOrderPopTemplate" placement="top" container="body" triggers="mouseenter:mouseleave"
                            [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.delivery-number', params: {deliveryNumber: shipment.shipmentNumber}}]"></span>
                        <span *ngIf="shipment.comment"> &nbsp; > &nbsp; {{shipment.comment}}</span>
                        <a class="stop-shipment-pod" *ngIf="shipment.pod" (click)="downloadPod(shipment.pod); $event.stopPropagation()">
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.pod', params: { filename: shipment.pod.filename }}]"></span>
                        </a>
                    </h2>
                    <ng-template #salesOrderPopTemplate>
                        <chp-delivery-and-sales-order-numbers
                            [deliveryNumbers]="[shipment.shipmentNumber]"
                            [salesOrderNumbers]="[shipment.salesOrderNumber]">
                        </chp-delivery-and-sales-order-numbers>
                    </ng-template>
                    <div class="ibox-tools">
                        <a class="collapse-link" draggable="false">
                            <i class="fa" [ngClass]="{ 'fa-plus': !shipment.expanded, 'fa-minus': shipment.expanded }"></i>
                        </a>
                    </div>
                </div>
                <div class="ibox-content no-padding stop-shipment-items" *ngIf="shipment.expanded">
                    <div *ngFor="let item of shipment.items" class="stop-shipment-item">
                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.item.line', params: { line: item.line }}]"></span>
                        <span *ngIf="item.productId" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.item.product-id', params: { productId: item.productId }}]"></span>
                        <span *ngIf="!item.productId" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.item.product-id-empty'}]"></span>
                        <span *ngIf="item.productDescription" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.item.product-description', params: { description: item.productDescription }}]"></span>
                        <span *ngIf="!item.productDescription" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.item.product-description-empty'}]"></span>
                        <span [i18n]="[{target: 'attribute:title', key: 'local-loads.search.details.item.pieces'}]">
                        <i class="fa fa-pallet"></i>
                            {{ item.pieces }}
                    </span>
                        <span [i18n]="[{target: 'attribute:title', key: 'local-loads.search.details.item.weight'}]">
                        <i class="fa fa-balance-scale"></i>
                            {{ item.weight }}
                    </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
